import { useRef } from 'react'

import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { Button, Row, Span } from 'components'
import { BorderLineSuccess } from 'components/BorderLine/BorderLine'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import { useModal } from 'hooks'
import Draggable from 'react-draggable'
import { FONTS, SPACING, TYPOGRAPHY, COLORS } from 'utils'
import { LoadingIcon } from 'components/Icons'

export const DinamicModal = () => {
  const draggableReference = useRef<Draggable>(null)

  const {
    closeModal,
    visible = false,
    showLoader = false,
    handleConfirm,
    handleCancel,
    handleThird,
    txtButtonThird = 'Voltar',
    hideButtonCancel = false,
    hideButtonConfirm = false,
    hideThirdButton = true,
    txtButtonCancel = 'Não',
    txtButtonConfirm = 'Sim',
    message = '',
    titleModal,
    type = 'alert',
    typeButtonThird = 'text',
    typeButtonCancel = 'text',
    typeButtonConfirm = 'default'
  } = useModal()

  const titlesModal = {
    alert: 'Alerta',
    error: 'Erro',
    success: 'Sucesso',
    info: 'Informação'
  }

  const colorModal = {
    alert: COLORS.alert,
    error: COLORS.error,
    success: COLORS.success,
    info: COLORS.darkGray
  }

  return (
    <DraggableDialog
      showModal={visible}
      width={'sm'}
      reference={draggableReference}
    >
      <BorderLineSuccess colorLine={colorModal[type]} />
      <DialogTitle>
        <Span
          color={colorModal[type]}
          text={!titleModal ? titlesModal[type] : titleModal}
          fontSize={TYPOGRAPHY.titleSize32}
          fontWeight={FONTS.bold}
        />
      </DialogTitle>
      <DialogContent>
        <Row marginBottom={SPACING.spacing30} justifyContent="flex-start">
          <Span
            color={COLORS.black}
            text={message}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.regular}
          />
        </Row>
        {showLoader && (
          <Row justifyContent="center" marginTop={SPACING.spacing5}>
            <LoadingIcon
              colorIcon={COLORS.blueFonts}
              width="32px"
              height="32px"
            />
          </Row>
        )}
        <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}></Row>
      </DialogContent>
      <DialogActions>
        {!hideThirdButton && (
          <Button
            text={txtButtonThird}
            onClick={
              handleThird
                ? () => {
                    handleThird()
                    closeModal()
                    resetModalState(draggableReference)
                  }
                : () => {
                    closeModal()
                    resetModalState(draggableReference)
                  }
            }
            variantButton={typeButtonThird}
            textColor={colorModal[type]}
          />
        )}
        {!hideButtonCancel && (
          <Button
            text={txtButtonCancel}
            onClick={
              handleCancel
                ? () => {
                    handleCancel()
                    closeModal()
                    resetModalState(draggableReference)
                  }
                : () => {
                    closeModal()
                    resetModalState(draggableReference)
                  }
            }
            variantButton={typeButtonCancel}
            borderColor={typeButtonCancel === 'outlined' && colorModal[type]}
            textColor={colorModal[type]}
          />
        )}
        {!hideButtonConfirm && (
          <Button
            text={txtButtonConfirm}
            onClick={
              handleConfirm
                ? () => {
                    handleConfirm()
                    closeModal()
                    resetModalState(draggableReference)
                  }
                : () => {
                    closeModal()
                    resetModalState(draggableReference)
                  }
            }
            borderColor={colorModal[type]}
            backgroundColor={colorModal[type]}
            textColor={COLORS.white}
            variantButton={typeButtonConfirm}
          />
        )}
      </DialogActions>
    </DraggableDialog>
  )
}
